import React, { useState } from 'react';
import { FolderAddOutlined } from '@ant-design/icons';
import { THEME_PALLETE } from '../Theme';
import {
    useProLanguage,
    PRO_TRANSLATIONS,
} from "../global/ProLanguageContext";

const NewFolderButton = ({ createNewFolder }) => {
    const { lang } = useProLanguage();
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).media;
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "7px 10px",
                cursor: "pointer",
                borderRadius: 4,
                fontSize: "14px",
                color: isHovered ? THEME_PALLETE.blue : THEME_PALLETE.darkgray,
                background: isHovered ? "#e6f4ff" : "transparent",
                transition: "background 0.15s, color 0.15s",
                width: "100%",
                boxSizing: "border-box",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={createNewFolder}
        >
            <span style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                <FolderAddOutlined style={{ fontSize: "20px" }} />
            </span>
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {t.newFolder || "New Folder"}
            </span>
        </div>
    );
};

export default NewFolderButton;